import i18n from "i18n";
import store from "stores";
import { PATH } from "router/config/const";
import { cloneDeep, size, isNil, pick, orderBy } from 'lodash';
import { userPriv, userInvalid } from "utils/privilege.util";
import Nuclias from "const/nuclias";
const { organizationType, userType, userPrivilege } = Nuclias;

const MORE_SITE_LIMIT = 100

const status = {
  SKIP_UPDATE: { requriedStatusType: 'error', status: 'd7c8c85bf7', target: '', details: '5e3026f80d' },
  UPDATE_COMPLETED: { requriedStatusType: 'success', status: '30ae8fff88', target: '', details: '263c0d8725' },
  UPDATE_FAILED: { requriedStatusType: 'error', status: 'd7c8c85bf7', target: '', details: '7f248cf950' }
}

export const defaultTreePathList = [
  { label: '6525f0afe7', isLink: false },
  { label: '85827d89ef', isLink: true, path: PATH.settings.organization },
  { label: '', isLink: false }
];

const mapTreeObj = (data, orgType) => {
  const ref = data.map(item => ({ ...item, orgType }));
  return orderBy(ref, [item => item.name.toLowerCase()], 'asc')
}

const getInfo = () => {
  const { user: { user }, pageContext } = store.getState();
  const res = { userType: user.type };
  res.isOrgUser = (user.type !== userType.sp && user.type !== userType.si) ? true : false;
  res.orgDs = pageContext.selectedOrg
  return res;
};

const translateList = (list) => {
  const t = i18n.t;

  let newList = list.map(data => {
    const orgTypleLabel = data.orgType === organizationType.tag ? '3039a00fca' : 'a7d6475ec8'
    return { ...data, orgTypleLabel: t(orgTypleLabel) }
  });
  return newList
}

const expandTree = (tagObj) => {
  let list = []
  const pickTag = pick(tagObj, ['id', 'name', 'orgType']);
  pickTag.parentStoreTagId = null;
  pickTag.parentTagName = '-'
  pickTag.index = 0
  list.push(pickTag)

  const findTag = (tags, parentTag, nestIndex = null) => {
    let index = nestIndex || 1
    const sortTag = mapTreeObj(tags, organizationType.tag)
    for (const tag of sortTag) {
      const tmpTag = pick(tag, ['id', 'name', 'orgType'])
      tmpTag.parentStoreTagId = parentTag?.id || null;
      tmpTag.parentTagName = parentTag?.name || '-'
      tmpTag.index = index;
      list.push(tmpTag)

      findTag(tag.storeTags, tmpTag, index + 1);
      findSite(tag.stores, tmpTag, index + 1);
    }
  }

  const findSite = (stores, parentTag, nestIndex = null) => {
    let index = nestIndex || 1
    const refSite = mapTreeObj(stores, organizationType.site)
    let newStores = refSite.map(data => {
      const tmp = pick(data, ['id', 'name', 'orgType'])
      tmp.parentStoreTagId = parentTag?.id || null
      tmp.parentTagName = parentTag?.name || '-'
      tmp.index = index
      return tmp;
    });
    list = list.concat(newStores)
  };
  findTag(tagObj.storeTags, null, 1);
  findSite(tagObj.stores, null, null);

  return list
}

const getOrgTreeList = (actions) => {
  return new Promise((Resolve, Reject) => {
    const { pageContext: { selectedOrg } } = store.getState();

    const refTag = mapTreeObj(selectedOrg.storeTags, organizationType.tag)
    let treeList = [];
    for (const tag of refTag) {
      const expandList = expandTree(tag)
      treeList = treeList.concat(expandList)
    }

    const refSite = mapTreeObj(selectedOrg.stores, organizationType.site)
    let newStores = refSite.map(data => {
      const tmp = pick(data, ['id', 'name', 'orgType']);
      tmp.parentStoreTagId = null;
      tmp.parentTagName = '-'
      tmp.index = 0
      return tmp;
    });
    treeList = treeList.concat(newStores)

    let conut = 0, moreIndexList = []
    treeList = treeList.map((item) => {
      if (item.orgType === organizationType.site) {
        conut++
        if (conut % MORE_SITE_LIMIT === 0) moreIndexList.push(item)
      }
      return { ...item, actions } //actions not ready
    })

    Resolve({ treeList: translateList(treeList), moreIndexList });
  });
};

const getOrgTree = () => {
  return new Promise(async (Resolve, Reject) => {
    const { pageContext: { selectedOrg } } = store.getState();
    const actions = {
      canEdit: !userPriv(userPrivilege.manager) && !userPriv(userType.siteTag),
      canDelete: !userPriv(userPrivilege.manager) && !userPriv(userType.siteTag)
    }

    const getNewTree = (tree) => {
      const res = tree.map((item) => {
        const list = pick(item, ['id', 'name', 'orgType']);
        list.actions = actions
        if (!isNil(item.storeTags)) {
          const tmpTag = mapTreeObj(item.storeTags, organizationType.tag)
          const tmpSite = mapTreeObj(item.stores, organizationType.site)
          list.childs = getNewTree(tmpTag.concat(tmpSite))
        }
        return list
      })
      return res
    }

    const refTag = mapTreeObj(selectedOrg.storeTags, organizationType.tag)
    const refSite = mapTreeObj(selectedOrg.stores, organizationType.site)
    const treeObj = getNewTree(refTag.concat(refSite))
    const { treeList, moreIndexList } = await getOrgTreeList(actions)

    Resolve({ treeObj, treeList, moreIndexList });
  });
};

const genPushDeviceResult = (resObj) => {
  if (size(resObj) === 0) return []
  const res = Object.values(resObj).map((item) => {
    const tmp = cloneDeep(status[item.state])
    tmp.target = item.name || item.uid
    return tmp
  })
  return res
}

export default {
  getInfo,
  getOrgTree,
  genPushDeviceResult
}